require("!!C:\\Users\\max.guglielmi\\Documents\\dev\\perso\\javascript\\GitHub\\TableFilter\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\max.guglielmi\\Documents\\dev\\perso\\javascript\\GitHub\\TableFilter\\node_modules\\raw-loader\\index.js!C:\\Users\\max.guglielmi\\Documents\\dev\\perso\\javascript\\GitHub\\TableFilter\\libs\\sortabletable.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./libs/sortabletable.js
// module id = 449
// module chunks = 0